export default "__VITE_ASSET__EVcrrupr__"